import {
  ContextApi,
  SourceTypeApi,
  ThreadApi,
  ThreadTypeApi,
} from 'api-typings/messages/messages_types';

export enum CommentFeedUpdateActionType {
  READ = 'read',
}

export interface CommentFeedPushPayload {
  readonly comment_feed: CommentFeedPayload;
}

export interface CommentFeedUpdatePayload {
  readonly action: CommentFeedUpdateActionType;
  readonly comment_feeds: ReadonlyArray<number>;
}

export type CommentFeedsPostApiResponse = ThreadApi;

export interface CommentFeedPayload {
  readonly message: MessagePayload;
  readonly context: ContextApi;
  readonly thread_type: ThreadTypeApi;
}

export interface MessagePayload {
  readonly message: string;
  readonly message_source?: SourceTypeApi;
}
